<template>
  <div class="navi-container"
       :style="{ 'background': backgroundColor, 'height': navigationBarHeightRem + 'rem','-webkit-box-shadow': boxShadow,'-moz-box-shadow': boxShadow,'box-shadow': boxShadow}">
    <div class="expand-top" :style="{ 'height': statusBarHeightRem + 'rem'  }"></div>
    <div class="navi-content" @touchmove.prevent
         :style="{ 'height' : (navigationBarHeightRem - statusBarHeightRem)+'rem'}">
      <div class="left-btn">
        <slot name="left"></slot>
      </div>
      <div class="title">
        <div v-if="title===''">
          <slot name="center"></slot>
        </div>
        <span v-else :style="{ 'color':textColor}">{{ title }}</span>
      </div>
      <div class="right-btn">
        <slot name="right"></slot>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'AuctionBar',
  props: {
    title: {
      type: String,
      default: ''
    },
    showBottomBorder: {
      type: Boolean,
      default: true
    },
    backgroundColor: {
      type: String,
      default: 'white'
    },
    textColor: {
      type: String,
      default: 'rgba(51, 51, 51, 1)'
    }
  },
  data() {
    return {
      boxShadow: 'rgba(204, 204, 204, 1) 0 0 4px',
      showBottom: this.showBottomBorder
    }
  },
  mounted() {
    this.setBottomBorder()
  },
  computed: {
    ...mapGetters(['getStatusBarH', 'getNavigationBarH']),
    statusBarHeightRem() {
      return this.getStatusBarH / 75.0
    },
    navigationBarHeightRem() {
      return (this.getStatusBarH + this.getNavigationBarH) / 75.0
    }
  },
  methods: {
    setBottomBorder() {
      this.boxShadow = this.showBottom ? 'rgba(204, 204, 204, 1) 0 0 4px' : 'rgba(204, 204, 204, 1) 0 0 0px'
    }
  },
  watch: {
    showBottomBorder: {
      immediate: true,
      handler: function (showBottomBorder) {
        this.showBottom = showBottomBorder
        this.setBottomBorder()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.navi-container {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 0.853rem;
  z-index: 100;

  .navi-content {
    overflow-y: hidden;
    padding-left: 0.16rem;
    padding-right: 0.16rem;
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: center;
    // border-bottom: 1px solid #F2F2F2;

    .left-btn, .right-btn {
      width: 0.4rem;
      height: 0.4rem;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .title {
      flex: 1;
      text-align: center;
      font-size: 0.24rem;
      font-weight: 400;
      line-height: 0.3rem;
      margin-left: 0.133rem;
      margin-right: 0.133rem;
      display: -webkit-box;
      overflow: hidden; /*超出宽度部分隐藏*/
      text-overflow: ellipsis; /*超出部分以点号代替*/
      -webkit-line-clamp: 1; /*行数*/
      -webkit-box-orient: vertical;
    }
  }
}
</style>
